// Vault data cache utility
const CACHE_TTL = 5 * 60 * 1000; // 5 minutes TTL

let vaultCache = {
  tvl: null,
  tokenPrice: null,
  apy: null,
  apy30Day: null,
  closingFee: null,
  maxDeposit: null,
  collateralizationP: null,
  timestamp: 0,
};

export const setVaultCache = (tvl, tokenPrice, extra = {}) => {
  vaultCache = {
    ...vaultCache,
    tvl,
    tokenPrice,
    ...extra,
    timestamp: Date.now(),
  };
};

export const getVaultCache = () => {
  const now = Date.now();
  const isExpired = now - vaultCache.timestamp > CACHE_TTL;

  if (isExpired || !vaultCache.tvl || !vaultCache.tokenPrice) {
    return null;
  }

  return { ...vaultCache };
};

export const clearVaultCache = () => {
  vaultCache = {
    tvl: null,
    tokenPrice: null,
    apy: null,
    apy30Day: null,
    closingFee: null,
    maxDeposit: null,
    collateralizationP: null,
    timestamp: 0,
  };
};
